export var source = "fragment Address on AddressGQL {\n  firstName\n  lastName\n  street\n  apt\n  zipCode\n  state\n  city\n  telephone\n}";
export default source;